import { IDeaRegistration, ValueLabel } from '../common';

export const registrationProperties: ValueLabel<keyof IDeaRegistration>[] = [
  { value: 'deaNum', label: 'DEA Registration Number' },
  { value: 'serialNumber', label: 'Certificate Serial Number' },
  { value: 'role', label: 'Role' },
  { value: 'regStatus', label: 'Role Status' },
  { value: 'certStatus', label: 'Certificate Status' },
  // { value: 'regStatus', label: 'Status' },
  { value: 'provisionDt', label: 'Provision Date' },
  { value: 'expDt', label: 'Expiration Date' },
  { value: 'busName', label: 'Business Name' },
  { value: 'busAddress', label: 'Business Mailing Address' },
  { value: 'orgAddress', label: 'Registrant Address' },
];
